/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from "axios";
window.axios = axios;

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

/**
 * Intercepteur pour gérer les erreurs 419 (Session Expired)
 * Recharge automatiquement la page pour renouveler le CSRF token
 */
window.axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 419) {
            console.warn('Session expirée, rechargement de la page...');
            window.location.reload();
        }
        return Promise.reject(error);
    }
);

import * as Sentry from "@sentry/browser";

Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN_PUBLIC,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,

    // This enables automatic instrumentation (highly recommended), but is not
    // necessary for purely manual usage
    integrations: [Sentry.browserTracingIntegration()],
    release:
        import.meta.env.VITE_SENTRY_APP_NAME +
        "@" +
        import.meta.env.VITE_SENTRY_RELEASE,

    // To set a uniform sample rate
    tracesSampleRate: Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE),

    enabled: import.meta.env?.VITE_SENTRY_ENVIRONMENT != "local",
});
